module.exports = __webpack_public_path__ + "static/media/shielding.db6887b3.svg";